import { Request as ORequest } from '@oscar/request';
import { Schema } from 'normalizr';
import { Table } from '@oscar/theme';

type Mode = 'REMOTE' | 'LOCAL';

export type ColumnType = Parameters<typeof Table>[0]['columns'];
export type SortOrder = Parameters<typeof Table['Column']>[0]['sortOrder'];

export enum KEYS {
  DEFAULTVALUE = 'defaultValues',
  DATA = 'data',
  MASTERDATA = 'masterData',
  LOADING = 'loading',
}
export interface Metadata {
  table: string;
  key: string;
  mode: Mode;
}

export type RequestParams = {
  pagination?: {
    pageIndex?: number;
    pageSize?: number;
    total?: number;
    [name: string]: any;
  };
  filters?: Record<string, any>;
  sorter?: {
    field: string;
    order: SortOrder;
    [name: string]: any;
  };
  [name: string]: any;
};

export type TableRef = {
  options?: TableOptions;
  selectors?: any;
  methods?: {
    fetchData: (params?: RequestParams) => void;
    getMetadata: () => RequestParams;
    reloadData: (params?: RequestParams) => void;
  };
};

export interface Request extends ORequest {
  schema?: Schema;
  params?: RequestParams;
}
export interface ResponseData<T> {
  metadata: Metadata;
  data: T;
}
export interface TableData {
  entities: {
    data: Record<string, any>;
    [name: string]: any;
  };
  result: {
    data: any[];
    metadata?: {
      pageIndex?: number;
      pageSize?: number;
      [name: string]: unknown;
    };
    [name: string]: any;
  };
  loading?: boolean;
}

export interface TableOptions {
  readonly name: string;
  readonly keyField: string;
  request?: Request;
  preload?: Request[];
  synchronize?: boolean;
  reducerName?: string;
  readonly mode?: Mode;
  defaultValues?: any;
  pageSize?: number;
  params?: RequestParams;
  columns?: ColumnType;
}

export interface RequestAction {
  request: Request;
  metadata: Metadata;
}
export interface TableAction {
  metadata: Metadata;
  data: any[];
}

export interface RowAction<T = { [name: string]: any }> {
  metadata: Metadata;
  rowKey: string | number;
  rowData: T;
}

export interface InitalAction {
  metadata: Metadata;
  options: TableOptions;
}

export interface ActionProps {
  uniqueKey?: string;
  hotReload?: boolean;
  onResponseData?: (data: any) => void;
  onLoading?: (data: any) => void;
  children?: (props: {
    doAction?: (request: Request, data?: any) => void;
    fetchData?: (params: RequestParams) => void;
  }) => React.ReactElement;
}

export interface MetadataView {
  table: TableRef | undefined;
  children?: (props: {
    table: TableRef | undefined;
    metadata: RequestParams;
  }) => React.ReactElement;
}
